import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WhatsappSettings } from '../model/whatsapp-settings-model';

const CONTROLLER = 'WhatsappSettings';

@Injectable({
  providedIn: 'root'
})
export class WhatasappSettingsService {

  constructor(private http: HttpClient) { }

  public getSendMessageWhatsapp(): Observable<boolean> {
    return this.http.get<boolean>(`${CONTROLLER}/sendMessageWhatsapp`)
      .pipe(
        map((response: any) => response),
        catchError(this.handleError)
      );
  }

  public getSendingByWhatsapp(): Observable<boolean> {
    return this.http.get<boolean>(`${CONTROLLER}/sendingByWhatsapp`)
      .pipe(
        map((response: any) => response.value),
        catchError(this.handleError)
      );
  }

  public createOrUpdate(whatsappSettings: WhatsappSettings): Observable<any> {
     return this.http.put(CONTROLLER, whatsappSettings);
  }

  private handleError(errorResponse: Response) {
    console.log(errorResponse.statusText);
    return throwError(errorResponse || 'Server error');
  }
}


